// @flow
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { connect } from '../../../base/redux';

import dummyPlaceholder from "./../../img/dummy-user.png"

import { hideApiLoader, setAvatarPop, setLoginModal, setLogoutType, setUserIsLogin, setUserLoginData, showApiLoader } from '../../redux/tool-webjam/actions';
import { FEATURE_CUSTOM_REDUX, FEATURE_CUSTOM_PAYMENT, FEATURE_CUSTOM_REDUX_V3 } from '../../constant';
import { getLJsonStorage, isMobileBrowser, usePrevious } from '../Utils';
import { getBaseConfig, isIpad, isSocialMobileApp } from '../../Utils';
import toast from 'react-simple-toasts';
import { getStripeLink, onUserLogout } from '../Request.d';
import { Constant } from '../../../webjam/constant';
import { setLeftMenuStatus, setPaymentSelectedPage, showPaymentDashboard } from './payment/payment-reducer/actions';
import { PaymentPages } from './payment/Utils';
import ConfirmationAlert from './payment/ConfirmationAlert';
import { setShowDeviceHelpingGuide } from '../../redux/tool-webjam-v3/actions';
import { openSettingsDialog, SETTINGS_TABS } from '../../../settings';
import { concatLargeString } from '../../custom/components/CommonComponents';
import { translate } from '../../../base/i18n';
import { messages } from '../messages';
import { ct } from '../../constant-Utils';
import { Translate } from '../../../webjam/language';
import { LinearProgressBar } from './ProgressBar';
import { GenericConfirmationModal } from '../../custom/components/GenericConfirmationModal';

const UserAvatar = (props) => {
    const [isActive, setIsActive] = useState(false);
    // const [username, setUsername] = useState('RTA User');
    const [username, setUsername] = useState('user');
    const [stripeActivated, setStripeActivated] = useState(false);
    const [isLogout, setIsLogout] = useState(false);

    const { t } = props;

    const dispatch = useDispatch();

    const activeToggle = () => {
        if (isActive) {
            dispatch(setAvatarPop(false))
            setIsActive(false)
        } else {
            dispatch(setAvatarPop(true))
            setIsActive(true)
        }
    }

    useEffect(() => {
        setUsername(getBaseConfig("userName"))
        let getLocalAuth = localStorage.getItem("auth");
        if (getLocalAuth) {
            getLocalAuth = JSON.parse(getLocalAuth);
            if (getLocalAuth.hasOwnProperty("username")) {
                setUsername(getLocalAuth.username);
            }
        }

        let hasConnect = getLJsonStorage("auth", "stripe_account_id");
        let hasVerified = getLJsonStorage("auth", "connectVerified");

        if (hasConnect && hasVerified == "approved") {
            setStripeActivated(true)
        }

    }, [])

    const { avatarPopShow } = props;
    const prevPop = usePrevious(avatarPopShow)

    useEffect(() => {
        if (prevPop != props.avatarPopShow) {
            if (props.avatarPopShow == false) {
                setIsActive(false)
            }
        }

    }, [props.avatarPopShow])

    const logoutUserWithSocial = async (status) => {
        if (status) {
            const userSocialId = props.userLoginData?.user?.rtaSocialUserId;
            const isSocialApp = isSocialMobileApp() ? true : false;
            if (isSocialApp) {
                // logout for mobile user
                await onUserLogout(userSocialId);
            }
            dispatch(setUserLoginData({
                isAdmin: false,
                isOpenRoom: false,
                isAlreadyPaid: false,
                isLogged: false,
                isOpenRoom: false,
                isPrivate: false,
                isRoomClaimed: false,
                data: '',
                room: '',
                user: ''
            }, 11));
            dispatch(showPaymentDashboard(false)); // to logout from dashboard as well
            localStorage.removeItem("auth");
            localStorage.removeItem("socialAuthToken");
            dispatch(setUserIsLogin(false));
            let socialBaseUrl = getBaseConfig("socialBaseUrl")
            if (!userSocialId) {
                // logout for invite user
                window.parent.location.href = socialBaseUrl
            }
            if (!isSocialApp && userSocialId) {
                // logout for normal web user
                window.parent.location.href = `${socialBaseUrl}/users/api_logout/${userSocialId}/false`;
            }
            setIsLogout(false);
        } else {
            setIsLogout(false);
        }
    }

    const logoutUser = async () => {
        if (confirm(t("rta-trmc.avatar.logoutConfirm"))) {
            localStorage.removeItem("auth");
            dispatch(setUserLoginData({
                isAdmin: false,
                isOpenRoom: false,
                isAlreadyPaid: false,
                isLogged: false,
                isOpenRoom: false,
                isPrivate: false,
                isRoomClaimed: false,
                data: '',
                room: '',
                user: ''
            }, 11));
            dispatch(showPaymentDashboard(false)); // to logout from dashboard as well
            dispatch(setLoginModal(true));
            dispatch(setUserIsLogin(false));
        }
    }


    useEffect(() => {
        if (props.dashboardLogin) {
            let getLocalAuth = localStorage.getItem("auth");
            if (getLocalAuth) {
                getLocalAuth = JSON.parse(getLocalAuth);
                if (getLocalAuth.hasOwnProperty("username")) {
                    setUsername(getLocalAuth.username);
                }
            }
        }
    }, [props.dashboardLogin])

    const handleLogin = () => {
        dispatch(setLoginModal(true));
    }

    const handleSignup = () => {
        sessionStorage.setItem("OpenSignup", 1)
        dispatch(setLoginModal(true));
    }

    const handleStripeDashboard = () => {
        dispatch(showApiLoader())
        getStripeLink()
            .then(async resp => {
                dispatch(hideApiLoader(12))
                if (resp.status == 1) {
                    let link = resp.data.data.link;
                    window.open(link, "_blank")
                } else {
                    if (resp?.message) {
                        let msg = await dynamicMessageLocale(resp.message);
                        toast(msg, Constant.App.ToastTime.LongCloseTime)
                    } else {
                        toast(ct("rta-trmc.dashboard.subscription.failed"), Constant.App.ToastTime.LongCloseTime)
                    }
                }
            })

    }

    const openDashboard = () => {
        const { isShowPaymentDashboard, userLoginData } = props;
        // social url change code
        let socialAllowed = getBaseConfig("socialAllowed");
        if (socialAllowed == true && (!userLoginData?.user?.is_app || !isSocialMobileApp())) {
            if (isShowPaymentDashboard) {
                window.parent.location.href = getBaseConfig('socialReferrerUrl');
            } else {
                window.parent.location.href = getBaseConfig('dashboardReferrerUrl')
            }
        } else {
            dispatch(showPaymentDashboard(!isShowPaymentDashboard));
            const isSideMenuOpen = (isMobileBrowser() || isIpad()) ? false : true;
            dispatch(setLeftMenuStatus(isSideMenuOpen));
            dispatch(setPaymentSelectedPage(PaymentPages.HOSTED_ROOM));
        }
    }

    const { isUserLogin, userLoginData, isShowPaymentDashboard, confirmationModalProps } = props;
    const userImage = getLJsonStorage("auth", "image_url") || dummyPlaceholder;

    return (
        <>
            {isLogout && (
                // <ConfirmationAlert
                //     handleConfirmAction={logoutUserWithSocial}
                //     title={ct("Translate.messages.logoutText")}
                //     className="muiModalMinWidth"
                // />

                <GenericConfirmationModal className="logout-confirmation-modal" title={t('dialog.logoutTitle')} content={ct("Translate.messages.logoutText")} onSuccess={() => logoutUserWithSocial(true)} onCancel={() => logoutUserWithSocial(false)}/>
            )}
            {
                confirmationModalProps?.isShow && confirmationModalProps?.type === 'dashboard' && <ConfirmationAlert  {...confirmationModalProps} >{confirmationModalProps?.content}</ConfirmationAlert>
            }

            <div className="user-menu-wrap avatar-dashboard">
                {isActive && <div aria-hidden="true" className="user-menu-backdrop" onClick={() => setIsActive(false)} style={{ opacity: 1, transition: "opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms" }} ></div>}
                <div id='user-avatar-menu' className="mini-photo-wrapper" onClick={() => activeToggle(true)}>
                    <div className="profile-highlight">
                        <div className="user-avatar-img">
                            <img id='user-avatar-img' onError={(e) => {
                                e.target.src = dummyPlaceholder;
                            }} src={userImage} />
                        </div>
                        {/* <div className="details">
                            <div id="profile-name">{userDetail?.first_name.length > 20 ? userDetail?.first_name : userDetail?.first_name + " " + userDetail?.last_name} </div>
                        </div> */}
                        <div>
                            <i className="fa fa-angle-down fa-2x"></i>
                        </div>
                    </div>
                </div>

                <div className={"menu-container " + (isActive ? "active" : '')}>
                    {props.showLoading ? <ul className="user-menu"> <li className="user-menu__item"><div className="user-menu-link pb-1">{t("rta-trmc.waitLoading")}</div></li></ul> : <ul className="user-menu" onClick={() => setIsActive(false)}>
                        {
                            (isUserLogin || userLoginData?.user?.username) ? <>
                                <div id='user-avatar-menu' className="mini-photo-wrapper">
                                    <div id="profile-picture" key="profile-picture" className="home-menu-list-profile d-flex" >
                                        <div className='menu-list-icons' style={{ borderBottom: 'none' }}>
                                            <div className="profile-highlight" style={{ borderBottom: 'none', paddingRight: '8px', paddingLeft: '8px' }}>
                                                <div className="user-avatar-img hexa-user-image">
                                                    <img id='user-avatar-img' onError={(e) => {
                                                        e.target.src = dummyPlaceholder;
                                                    }} src={userImage} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='home-menu-list-username'>
                                            <b className='home-menu-list-text'>{concatLargeString(getLJsonStorage("auth", "username") || userLoginData?.user?.username || username, 20)}</b>
                                            <p className='home-menu-list-text user-email-text-color'>{concatLargeString(userLoginData?.user?.email || userLoginData?.user?.phone, 27)}</p>
                                            <LinearProgressBar />
                                        </div>
                                    </div>
                                </div>
                                {
                                    stripeActivated && getBaseConfig("paidLecture") == true &&
                                    getBaseConfig("showMenuList") && <div onClick={() => handleStripeDashboard()} id="stripe-dashboard" key="1" className="home-menu-list pl-4 d-flex" >
                                        <span className='mr-2'><i className="fa fa-desktop home-menu-list-dashboard-icon" /></span>
                                        <span className='home-menu-list-text'>{t("rta-trmc.avatar.stripe_dashboard")}</span>
                                    </div>
                                }
                                {getBaseConfig("showMenuList") && getBaseConfig("showRoomDashboard") && !getBaseConfig("showHomePageHomeIcon") ?
                                    <div onClick={() => openDashboard()} id={isShowPaymentDashboard ? 'home-btn' : 'dashboard-btn'} key="2" className="home-menu-list pl-4 d-flex" >
                                        <div className='menu-list-icons'><i className="fa fa-desktop home-menu-list-dashboard-icon" /></div>
                                        <span className='home-menu-list-text'>{isShowPaymentDashboard ? t("rta-trmc.avatar.home") : ct("rta-trmc.avatar.dashboard")}</span>
                                    </div>

                                    :
                                    <>
                                        {
                                            isShowPaymentDashboard && getBaseConfig("showMenuList") &&
                                            <div onClick={() => openDashboard()} id={isShowPaymentDashboard ? 'home-btn' : 'dashboard-btn'} key="3" className="home-menu-list pl-4 d-flex" >
                                                <div className='menu-list-icons'><i className="fa fa-desktop home-menu-list-dashboard-icon" /></div>
                                                <span className='home-menu-list-text'>{isShowPaymentDashboard && t("rta-trmc.avatar.home")}</span>
                                            </div>
                                        }
                                    </>
                                }
                                {!isShowPaymentDashboard && getBaseConfig("showMenuList") && getBaseConfig("deviceHelp") == true && <div id='troubleshooting-rta-device' className="home-menu-list pl-4 d-flex" onClick={() => {
                                    dispatch(setShowDeviceHelpingGuide(true))
                                }} >
                                    <div className='menu-list-icons'><i className='fa fa-lightbulb-o home-menu-list-icon' /></div>
                                    <span className='home-menu-list-text'>{ct("rta-trmc.avatar.troubleShot")}</span>
                                </div>}
                                {!isShowPaymentDashboard && getBaseConfig("showMenuList") && getBaseConfig("deviceHelp") == true && <div id='rta-settings' className="home-menu-list pl-4 d-flex" onClick={() => {
                                    dispatch(setAvatarPop(false));
                                    dispatch(openSettingsDialog(SETTINGS_TABS.CALENDAR));
                                }} >
                                    <div className='menu-list-icons'><i className='fa fa-cog home-menu-list-icon' /></div>
                                    <span className='home-menu-list-text'>{t("rta-trmc.avatar.webcamRoomSetting")}</span>
                                </div>}
                                {!isShowPaymentDashboard && getBaseConfig("showMenuList") && getBaseConfig("showSignOutButton") && getBaseConfig("socialAllowed") && !isSocialMobileApp() && <div id='rta-social-netwrok' key="rta-social" className="home-menu-list pl-4 d-flex" onClick={() => {
                                    window.parent.location.href = Constant.App.socialUrl;
                                }} >
                                    <div className='menu-list-icons'><img src={getBaseConfig("socialWebIconBlack")} height="16px" /></div>
                                    <span className='home-menu-list-text'>{t("rta-trmc.avatar.rtaSocial")}</span>
                                </div>
                                }
                                {getBaseConfig("showMenuList") && getBaseConfig("showSignOutButton") && getBaseConfig("socialAllowed") &&
                                    <div id='rta-sign-out-link' key="4" className="home-menu-list pl-4 d-flex" style={{ borderBottom: 'none' }} onClick={() => {
                                        if (isShowPaymentDashboard) {
                                            setIsLogout(true);
                                        } else {
                                            dispatch(setLogoutType(true));
                                        }
                                    }} >
                                        <div className='menu-list-icons' style={{
                                            float: "left"
                                        }}><i className="fa fa-sign-out tool home-menu-list-icon" /></div>
                                        <span className='home-menu-list-text'>{t("rta-trmc.avatar.logout")}
                                        </span>
                                    </div>
                                }
                                {
                                    !getBaseConfig("socialAllowed") && <li className="user-menu__item">
                                        <div className="user-menu-link user-logout" >
                                            <button className="theme-btn logout-btn wel-page" onClick={() => logoutUser()}>{t("rta-trmc.avatar.signOut")}</button>
                                        </div>
                                    </li>

                                }
                            </> : <>
                                {!getBaseConfig("socialAllowed") &&
                                    <>
                                        <li className="user-menu__item">
                                            <div className="user-menu-link user-logout pb-1" >
                                                <button className="theme-btn wel-page logout-btn" onClick={handleLogin}>{t("rta-trmc.avatar.signIn")}</button>
                                            </div>
                                        </li>
                                        <li className="user-menu__item">
                                            <div className="user-menu-link user-logout" >
                                                <button className="theme-btn wel-page logout-btn" onClick={handleSignup} >{t("rta-trmc.avatar.signUp")}</button>
                                            </div>
                                        </li>
                                    </>
                                }
                            </>
                        }
                    </ul>}
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        //userDetail: state["features/welcome-dashboard"].userDetail,
        isUserLogin: state[FEATURE_CUSTOM_REDUX].isUserLogin,
        dashboardLogin: state[FEATURE_CUSTOM_REDUX].dashboardLogin,
        avatarPopShow: state[FEATURE_CUSTOM_REDUX].avatarPopShow,
        userLoginData: state[FEATURE_CUSTOM_REDUX].userLoginData,
        isShowPaymentDashboard: state[FEATURE_CUSTOM_PAYMENT].isShowPaymentDashboard,
        showLoading: state[FEATURE_CUSTOM_REDUX].showLoader,
        confirmationModalProps: state[FEATURE_CUSTOM_REDUX_V3].confirmationModalProps,
    }
}

export default translate(connect(mapStateToProps)(UserAvatar));